import { SingleSelectGroup } from '@doordash/component-select-group';
import Toggle from '@doordash/component-toggle';
import { InlineChildren, StackChildren, Text } from '@doordash/design-language';
import * as React from 'react';
import { BUDGET_REFRESH_INTERVAL, BUDGET_TYPE_SELECT, budgetTypeRecurringOptions, } from '../budget_helper';
import { InputContainer } from './budget_form_styles';
import { BudgetModalTestId } from '../../../testId';
export var BudgetTypeSelector = function (_a) {
    var values = _a.values, errors = _a.errors, setFieldValue = _a.setFieldValue;
    return (React.createElement(React.Fragment, null,
        React.createElement(StackChildren, { size: StackChildren.Sizes.XxSmall },
            React.createElement(Text, { styles: Text.Styles.Medium14 }, "Budget type"),
            React.createElement(InputContainer, { size: "large" },
                React.createElement(SingleSelectGroup, { accessibilityLabel: 'Budget type', type: SingleSelectGroup.Types.PrimaryPill, defaultSelectedIndex: values.budgetTypeSelect, options: BUDGET_TYPE_SELECT, "data-testid": BudgetModalTestId.BudgetTypeSelector, onChange: function (value) {
                        setFieldValue('budgetTypeSelect', value);
                        setFieldValue('budgetRefreshInterval', value);
                    } }))),
        Boolean(values.budgetRefreshInterval !== BUDGET_REFRESH_INTERVAL.OneTime) ? (React.createElement(StackChildren, { size: StackChildren.Sizes.XxSmall },
            React.createElement(Text, { styles: Text.Styles.Medium14 }, "Budget Frequency"),
            React.createElement(InlineChildren, { size: InlineChildren.Sizes.Large }, budgetTypeRecurringOptions.map(function (option) {
                var isSelected = Boolean(values.budgetRefreshInterval === option.value);
                return (React.createElement(Toggle, { key: option.value + "_" + option.label, label: option.label, name: "recurring-options", isSelected: isSelected, type: Toggle.Types.Radio, onChange: function () {
                        return setFieldValue('budgetRefreshInterval', option.value);
                    } }));
            })),
            Boolean(errors.budgetRefreshInterval) ? (React.createElement(Text, { color: Text.Colors.TextError, styles: Text.Styles.Medium12 }, errors.budgetRefreshInterval)) : null)) : null));
};
export default BudgetTypeSelector;
